export function ArtLabelSection() {
  return (
    <div className="text-5xl max-sm:text-2xl text-center">
      Welcome to my art gallery!
      <br /> If you want to see more, check out my{" "}
      <a
        className="underline"
        target="_blank"
        rel="noreferrer"
        href="https://www.pixiv.net/en/users/53872777"
      >
        Pixiv
      </a>
    </div>
  );
}
